import { render } from "./Sosoceo.vue?vue&type=template&id=6e912eed&scoped=true"
import script from "./Sosoceo.vue?vue&type=script&lang=js"
export * from "./Sosoceo.vue?vue&type=script&lang=js"

import "./Sosoceo.vue?vue&type=style&index=0&id=6e912eed&scoped=true&lang=css"

import exportComponent from "/home/withpd/git/geek9_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e912eed"]])

export default __exports__